



























































import { Vue, Component } from 'vue-property-decorator';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomInput from '@/components/Globals/Form/CustomInput.vue';
import CustomText from '@/components/Globals/CustomText.vue';
import CustomTooltip from '@/components/Globals/CustomTooltip.vue';
import EmbroideryImagesView from '@/components/molecule.embroidery.imagesView.vue';

import mainView from '@/mixins/Embroidery/MainView';

@Component({
  components: {
    CustomContainer,
    CustomInput,
    CustomText,
    EmbroideryImagesView,
    CustomTooltip
  },
  mixins: [mainView],
})
export default class EmbroideryMainVue extends Vue {}
